import cn from 'classnames';
import _ from 'lodash';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import ImageViewer from 'react-simple-image-viewer';
import PostingsApi from '../../../../../API/shipment/postings-api';
import { Column, Row } from '../../../../../components/Basic/Blocks';
import { CheckButton } from '../../../../../components/Basic/Buttons';
import { DateInput, Input, Select } from '../../../../../components/Basic/Inputs';
import { TableCell, TableLine } from '../../../../../components/Basic/Table';
import { TextGrey } from '../../../../../components/Basic/WrapsStyle';
import BarcodesBlock from '../../../../../components/Common/Input/Barcodes';
import { MAP_SKLAD_SHORT, MAP_SKLAD_SHORT_ANOTHER } from '../../../../../constans';
import { getDateSolid, getProviderNew, setDateSolid } from '../../../../../utils';
import { WIDTH_POSTING } from '../index';
import styles from './styles.module.scss';


const OrderLine = ({
  // MODES,
  // FILTER,
  // tab,
  productAlt,
  listNameColor,
  changePositionsCheck = () => _,
  postitionsChecked = {},
  shipmentMode = true,
  order = {},
  LIST_MARKETS = {},
  pricesMode,
  rebuyMode,
  shipment = {},
  providers = [],
  map = {},
  isAdmin = false,
  onChangeOrderData = () => _,
  ...props
}) => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const [images, setImages] = useState([]);
  const [showModalRebuy, setShowModalRebuy] = useState(false);

  const dispatch = useDispatch();
  const onChangeProduct = async (id, productId, field, value, action = undefined) => {
    onChangeOrderData({ data: { orderProductId: order._id, productId, field, value, action } })
    // .then((r) => {
    // dispatch(changeShipmentPosting(r.posting));
    // });
  };

  const changePosting = async ({ postingNumber, field, value }) => {
    await PostingsApi.changePosting({ data: { postingNumber, field, value } })
    // .then((r) => {
    // dispatch(changeShipmentPosting(r.posting));
    // });
  };

  const openImageViewer = (images) => {
    setImages(images);
    setIsViewerOpen(true);
  };
  const closeImageViewer = () => {
    setIsViewerOpen(false);
    setImages([]);
  };

  let imgs = map[order.offer_id]?.images || [];

  let statusColor
  switch (order.status) {
    case 'Без листа': statusColor = '#54545459'; break
    case 'Резерв': statusColor = '#00cc3dc4'; break
    case 'Отправлен заказ': statusColor = '#fef6aeff'; break
    case 'Заказано': statusColor = 'springgreen'; break
    case 'Не заказано': statusColor = '#feaeaeff'; break
    case 'Нет в наличии': statusColor = '#ff5151ff'; break
    case 'Не хватает': statusColor = 'yellow'; break
    case 'Частичный резерв': statusColor = '#b1e327ff'; break
    case 'Излишки': statusColor = '#b78eedff'; break
  }

  return (
    <>
      <TableLine isMinus={(order.profit && order.profit <= 10) ? true : false}>
        <TableCell width={WIDTH_POSTING[9]}>
          <CheckButton
            checked={postitionsChecked[order._id]}
            onSelect={() => changePositionsCheck(order._id)}
          // disabled={is_disabled_print}
          />
        </TableCell>
        <TableCell width={WIDTH_POSTING[10]}>
          <Row style={{ fontWeight: 'bold', fontSize: '16px' }}>{getProviderNew(order.provider_id, providers).name}</Row>
        </TableCell>
        <TableCell width={WIDTH_POSTING[1]}>
          <Column>
            <div className={styles.div_line_images}>
              <div className={styles.wrapper}>
                <img
                  onClick={() => openImageViewer(imgs)}
                  className={styles.preview}
                  src={imgs.length > 0 ? imgs[0] : undefined}
                />
              </div>
              <Column>
                <div className={styles.name}>
                  {`${order.ordered_quantity} x ${order.name}  `}
                  <div className={cn(styles.offer_id)}>{order.offer_id}</div>
                </div>
              </Column>
            </div>
          </Column>
        </TableCell>
        <TableCell center={true} width={'90px'} >
          <Row >
            {order.market === 'wb' && (
              <TextGrey style={{ fontSize: '13px', color: '#6c11c9' }}>{order.shop}</TextGrey>
            )}
            {order.market === 'yandex' && (
              <TextGrey style={{ fontSize: '13px', color: 'rgb(193 61 0)' }}>{order.shop}</TextGrey>
            )}
            {order.market === 'ozon' && (
              <TextGrey style={{ fontSize: '13px', color: 'rgb(19,79,231)' }}>{order.shop}</TextGrey>
            )}
            {order.market === 'megamarket' && (
              <TextGrey style={{ fontSize: '13px', color: 'rgb(13,131,25)' }}>{order.shop}</TextGrey>
            )}
          </Row>
        </TableCell>
        <TableCell width={WIDTH_POSTING[16]} center={true}>
          <Row
            style={{ padding: '5px 8px', fontWeight: 'bold', borderRadius: '6px', backgroundColor: listNameColor?.color }}
          >{listNameColor?.listName}</Row>
        </TableCell>
        <TableCell width={WIDTH_POSTING[0]} center={true}>
          <Row>{order.provider_artnumber}</Row>
        </TableCell>
        <TableCell width={WIDTH_POSTING[15]} center={true}>
          <Row>{order.common_quantity}</Row>
        </TableCell>
        <TableCell width={WIDTH_POSTING[6]} center={true}>
          <Row>
            {/* {
              order.stat_quantity?.reserved > 0 ?
                <div style={{ fontSize: '14px', fontWeight: 'bold', color: 'green' }}>{order.stat_quantity?.reserved + ' + '}</div> : null
            } */}
            {/* <div>{order.stat_quantity?.ordered}</div> */}
            {/* <div>{' / ' + order.stat_quantity?.need}</div> */}
            {order.stat_quantity?.freezed > 0 ? <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#a50189ff' }}>{order.stat_quantity?.freezed + ' + '}</span> : ''}
            {order.stat_quantity?.reserved > 0 ? <span style={{ fontSize: '14px', fontWeight: 'bold', color: 'green' }}>{order.stat_quantity?.reserved + ' + '}</span> : ''}
            {`${order.stat_quantity?.ordered} / ${order.stat_quantity?.need}`}
          </Row>
        </TableCell>
        <TableCell center={true} width={WIDTH_POSTING[0]}>
          <div
            style={{ cursor: 'pointer', padding: '7px 10px', fontWeight: 'bold', borderRadius: '6px', backgroundColor: statusColor }}
            onClick={e => { ['Не заказано', 'Нет в наличии'].includes(e.target.innerText) && onChangeOrderData({ orderProductId: order._id, field: 'is_not_available', value: e.target.innerText === 'Не заказано' }) }}
          >
            {`${order.status}${order.diff_value ? ' (' + (['Не хватает', 'Излишки'].includes(order.status) ? Math.abs(order.diff_value) : order.diff_value) + ')' : ''}`}
          </div>
        </TableCell>
        <TableCell width={WIDTH_POSTING[0]} >
          <Input value={order.comment}
            onBlur={value => onChangeOrderData({ orderProductId: order._id, field: 'comment', value })} center />
        </TableCell>
        <TableCell width={WIDTH_POSTING[10]} >
          <Column>
            <div className={styles.div_line}>
              <Select
                select={MAP_SKLAD_SHORT[order.skladName]}
                list={['Мск', 'Екб']}
                style={{ fontSize: '14px' }}
                width={'75px'}
                disabled={order.market !== 'wb'}
                // disabled={true}
                onSelect={(v) => {
                  onChangeOrderData({ orderProductId: order._id, field: 'skladName', value: MAP_SKLAD_SHORT_ANOTHER[v] })
                  changePosting({ postingNumber: order.posting_numbers[0], field: 'skladName', value: MAP_SKLAD_SHORT_ANOTHER[v] })
                }}
              />
            </div>
          </Column>
        </TableCell>
        {pricesMode && <>
          <TableCell width={WIDTH_POSTING[10]} center={true}>
            <Row>{Math.round(order.price)}</Row>
          </TableCell>
          <TableCell width={WIDTH_POSTING[10]} center={true}>
            <Row>{Math.round(order.commission) || null}</Row>
          </TableCell>
          <TableCell width={WIDTH_POSTING[10]} center={true}>
            <Row>{Math.round(order.order_data?.purchase) || null}</Row>
          </TableCell>
          <TableCell width={WIDTH_POSTING[10]} center={true}>
            <Row>{Math.round(order.profit) || null}</Row>
          </TableCell>
        </>}
        <TableCell width={WIDTH_POSTING[0]} center={true}>
          <div style={{ ...(['Нет в наличии', 'Не заказано', 'Без листа', 'Резерв'].includes(order.status) && { pointerEvents: 'none' }) }}>
            <DateInput
              className={styles.date_input}
              classNameCalendar={styles.date_input_calendar}
              value={order.dates.arrive && getDateSolid(order.dates.arrive)}
              onChange={(v) =>
                onChangeOrderData({ orderProductId: order._id, field: 'date_arrive', value: setDateSolid(v) })
              }
            />
          </div>
        </TableCell>
        <TableCell width={WIDTH_POSTING[7]} center={true}>
          <div style={{ width: '200px' }}>
            <BarcodesBlock
              barcodes={order.barcodes}
              onAdd={(b) => onChangeOrderData({ orderProductId: order._id, field: 'barcodes', value: b, action: 'add' })}
              onRemove={(b) => onChangeOrderData({ orderProductId: order._id, field: 'barcodes', value: b, action: 'pull'  })}
            />
          </div>
        </TableCell>

        {isViewerOpen && <ImageViewer src={images} currentIndex={0} onClose={closeImageViewer} />}
      </TableLine >

    </>
  );
};

export default OrderLine;
